import EmberDataBaseAdapter from '@square/dashboard-data/adapters/ember-data-base-adapter';
import { inject as service } from '@ember/service';
import VerifyAndLinkInstrumentResponse from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/verify-and-link-instrument-response';
import { v4 as uuid } from 'uuid';
export default EmberDataBaseAdapter.extend({
  instruments: service(),
  generateIdForRecord() {
    return uuid();
  },
  createRecord(store, type, snapshot) {
    return this.linkInstrument(snapshot.record);
  },
  updateRecord(store, type, snapshot) {
    return this.linkInstrument(snapshot.record);
  },
  linkInstrument(record) {
    return record.toVerifyAndLinkInstrumentParams().then(this.instruments.verifyAndLinkInstrument).then(function (response) {
      // Verify and Link Instrument returns a 200 on card link failure, so we throw an exception here
      if (response.get('status') !== VerifyAndLinkInstrumentResponse.Status.SUCCESS) {
        throw response;
      }

      // Verify And Link Instrument returns an instrument summary which we need for displaying linked cards on file
      record.set('instrument', response.get('instrument'));

      // We don't have a payload, and returning the card record confuses Ember Data
      return null;
    });
  }
});